import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { nomService } from '../../services/api/nom.service';
import { mmPreauthorizationService } from '../../services/api/mmPreauthorization.service';
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";
import { ListDialog } from "../shared/listDialog";


export const MMPreauthorizationNoxes = (props) => {

    const _newRow = {
        id: 0,
        idPreautorizare: props.id ? props.id : 0,
        idNoxa: 0,
        statusFinanciar: null

    };
    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([]);
    const [dropdown, setDropdown] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [newRow, setNewRow] = useState(_newRow);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {

        if (props && props.id) {
            mmPreauthorizationService.getNoxes({ preauthorizationId: props.id })
                .then(response => {
                    if (response) {
                        setList(response);
                        props.actualizareNoxe(response);
                    }

                });
        }
    }, [props.id, props.refresh]);

    useEffect(() => {
        if (list.length > 0) {
            nomService.getNoxes()
                .then(response => {
                    if (response) {
                        setDropdown(response);

                        // Setez defaulturile
                        if (list.length > 0 && response.length > 0) {
                            var d = [];
                            for (var item in list) {
                                var el = utils.findObjectById(response, list[item].idNoxa)
                                d.push(el);
                            }
                            setDefaults(d);
                        }
                    }

                });
        }
    }, [list]);


    
    const handleAdd = () => {
        const updatedList = [...list, newRow];
        setList(updatedList);
        props.actualizareNoxe(updatedList);
        setNewRow(_newRow);
    }
    

    const handleDelete = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta noxa?"
            , () => {
                const updatedList = [...list];
                updatedList.splice(index, 1);
                setList(updatedList);
                props.actualizareNoxe(updatedList);
            }
            , () => { return; }
        );

    };


    const handleChange = (event, index) => {
        const selectedValue = event.target.value;

        // Creează o copie nouă a listei
        const updatedList = [...list];

        // Actualizează valoarea corespunzătoare în lista copiată
        updatedList[index].idNoxa = selectedValue.id;

        // Actualizează lista cu noua listă modificată
        setList(updatedList);
        props.actualizareNoxe(updatedList);

        //reseteaza search term 
        setSearchTerm("");
       
    };

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {

        let newList = [...list];
        newList[clickedIndex].idNoxa = dropdown[item].id;
        setList(newList);
        props.actualizareNoxe(newList);
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };


    const filtred = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;

    return (
        <>
            <label className="pt20 pb5">Noxe <span className="red">*</span></label>
            <table className="tbl tbladd" name="lista_noxe" width="100%">
                <thead>
                    <tr>
                        <th>Noxe</th>
                        {
                            props.statusFinalizare != 1 &&
                            <>
                                <th width="30">Editeaza</th>
                                <th width="30">Sterge</th>
                            </>
                        }
                    </tr>
                </thead>
                <tbody>
                    {list.map((item, index) => (
                        <tr key={index}>

                            <td>
                                <DropDownList className="w360 fl"
                                    name="idNoxa"
                                    data={filtred}
                                    filterable
                                    onFilterChange={handleFilterChange}
                                    textField="text"
                                    dataItemKey="id"
                                    value={defaults[index]}
                                    onChange={(event) =>
                                        handleChange(event, index)
                                    }
                                    disabled={props.statusFinalizare === 1}
                                />
                            </td>

                            {
                                props.statusFinalizare != 1 &&
                                <>
                                <td className="center" name="noxe_edit" onClick={ () => handleClick( index ) }>
                                    <span className="icon modifica center"></span>
                                </td>
                                <td className="center" name="noxe_del" onClick={() => handleDelete(index)}>
                                    <span className="icon sterge center"></span>
                                </td>
                            </>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            {props.statusFinalizare != 1 && <button name="adauga_noxe" className="btn" onClick={handleAdd}>Adauga noxe</button>}


            {showDialog && <ListDialog title="Noxe"
                data={dropdown}
                handleDialog={handleDialog}
                handleReturn={handleReturn } />}
        </>
    );
}